import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay, tap } from 'rxjs';
import { ConfigService } from './config.service';

export interface UserPermission {
  id: string;
  name: string;
  description: string;
  resourceId: string;
}

interface UserMeResponse {
  roles: { id: string; name: string; description: string }[];
  permissions: UserPermission[];
}

/**
 * Loads and caches the current user's roles and permissions from /api/user/me.
 * Shared between ToolbarComponent and permission guards.
 */
@Injectable({ providedIn: 'root' })
export class UserPermissionsService {
  private cache$?: Observable<UserMeResponse>;

  isAdmin = false;
  permissions: UserPermission[] = [];

  constructor(
    private readonly http: HttpClient,
    private readonly config: ConfigService
  ) {}

  load(): Observable<UserMeResponse> {
    if (!this.cache$) {
      this.cache$ = this.http.get<UserMeResponse>(`${this.config.config.apiUrl}/api/user/me`).pipe(
        tap(({ roles, permissions }) => {
          this.isAdmin = roles.some(r => r.name === 'Admin');
          this.permissions = permissions;
        }),
        shareReplay(1)
      );
    }
    return this.cache$;
  }

  /** Call after sign-out to reset cached state. */
  clear(): void {
    this.cache$ = undefined;
    this.isAdmin = false;
    this.permissions = [];
  }

  hasPermission(name: string): boolean {
    return this.permissions.some(p => p.name === name);
  }
}
